import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import PatternStyle from "../../style/PatternStyle";
import ColorInput from "../../../general/ColorInput";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import RadioInput from "@builder/components/general/RadioInput";
import { DividerNode } from "@common/build/types";
import SliderInput from "@builder/components/general/SliderInput";
import { PATTERNS_WITH_GAP } from "@common/components/BuilderDivider/patterns/DividerPatterns";

const LineStyling: React.FC<EditableProps> = ({ parent, excluded = [] }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as DividerNode;
    if (!node) return null;
    const showType = !excluded.includes("type");
    const showColor = !excluded.includes("color");
    const showGap = !excluded.includes("gap") && PATTERNS_WITH_GAP.includes(node.pattern as any);
    const { t } = useTranslation();
    const { color, gap } = node.patternStyle || {}; 

    const colorCallback = (value: string) => {
        dispatch(
            updateNodeProperty({
                propertyPath: ["patternStyle", "color"],
                value
            })
        );
    };
    const patternDirectionCallback = (value: string) => {
        dispatch(
            updateNodeProperty({
                propertyPath: ["isVertical"],
                value : value === "vertical"
            })            
        );
        dispatch(
            updateNodeProperty({
                propertyPath: ["attr", "style", "width"],
                value : node?.attr?.style?.height?.toString() || "100%"
            })            
        );
        dispatch(
            updateNodeProperty({
                propertyPath: ["attr", "style", "height"],
                value : node?.attr?.style?.width?.toString() || "100%"
            })            
        );
    };

    const gapCallback = (value: string) => {
        dispatch(
            updateNodeProperty({
                propertyPath: ["patternStyle", "gap"],
                value
            })
        );
    };

    const patternDirectionOptions = [
        { 
            value: "horizontal", 
            img: "/arrow-right-long.svg", 
            checked: !node?.isVertical, 
            tooltip: t("generalComponents.radioInput.Horizontal") 
        },
        { 
            value: "vertical", 
            img: "/arrow-down-long.svg", 
            checked: !!node?.isVertical, 
            tooltip: t("generalComponents.radioInput.Vertical") 
        }
    ];

    return (
        <SidebarCollapse title={showType ? "Line Setup" : "Line Styling"} parent={parent}>
            {showType && <PatternStyle />}

            {!excluded?.includes("patternDirection") && (
                <RadioInput
                    title="Pattern Direction"
                    groupName="pattern-direction"
                    options={patternDirectionOptions}
                    callback={patternDirectionCallback}
                />
            )}

            {showGap && <SliderInput title={"Gaps"} value={gap?.toString()} unit="px" min={0} max={100} callback={gapCallback} />}

            {showColor && <ColorInput title="Line Color" color={color} callback={colorCallback} />}
        </SidebarCollapse>
    );
};

export default LineStyling;
